export const FORMULA_MAX_BINDINGS = 3;

export enum FormulaType {
  Template = 'template',
  Custom = 'custom',
}

export interface FormulaBindingSource {
  DeviceID: string;
  PointID: string;
  Transformations?: {
    Multiplier?: number;
    Conversion?: string;
    Offset?: number;
  };
}

export interface FormulaBinding {
  Variable: string;
  Source: FormulaBindingSource;
}

export interface FormulaExpression {
  Type: FormulaType;
  Value: string;
}

export interface FormulaPoint {
  ID: string;
  Formula: FormulaExpression;
  Bindings: FormulaBinding[];
  Principals?: {
    TileIDs: string[];
  };
}

export interface FormulaConfig {
  Points: FormulaPoint[];
}
